var _rect, _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 13,
    rx: 0.5,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91304 1C4.91304 3.16111 3.16111 4.91304 1 4.91304",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1C17 3.16111 18.752 4.91304 20.9131 4.91304",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91304 12.9141C4.91304 10.7529 3.16111 9.00102 1 9.00102",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.9141C17 10.7529 18.752 9.00102 20.9131 9.00102",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7,
    r: 2.5,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/MoneyIcon.f3afb09478e0d9ed4dc7bb4d9f51ddbb.svg";
export { ForwardRef as ReactComponent };